import { render } from "./IconFilter.vue?vue&type=template&id=673519a1"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconFilter.vue"]])

export default __exports__